// extracted by mini-css-extract-plugin
export default {"PFSFooter":"PFSFooter_PFSFooter__bdD81","FooterWaveContainer":"PFSFooter_FooterWaveContainer__bI6lQ","FooterWave":"PFSFooter_FooterWave__I6kuh"};